import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Theme, ThemeProvider } from '@emotion/react';
import 'dayjs/locale/de';
import App from './App';
import boot from './Config/config';
import * as serviceWorker from './serviceWorker';

import initI18next from './Translations/setup';

// ATTENTION: in prod you do not want to async load the config
// because time to render - just hardcode (or replace via build) in Config/config!
initI18next().then(() =>
  boot().then(() => {
    async function getTheme(): Promise<Theme | {}> {
      let theme;
      await import('./Theme/Styles/MASTERDATA/dto/theme').then(t => {
        theme = t.default;
      });

      return theme || {};
    }

    getTheme().then(theme => {
      ReactDOM.render(
        <ThemeProvider theme={theme}>
          <Suspense fallback="...">
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </Suspense>
        </ThemeProvider>,
        document.getElementById('root')
      );
    });
  })
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
